/**
 * Your cards from the Money page, offered wherever you pick a card (the item editor, receipts,
 * the ledger), so a card added on the Money page doesn't also need adding in each group's
 * settings. Only the treasurer has Money cards; members just see their group's list.
 */
import { cardLabel, type MoneyAccount } from "@split/core";
import { api } from "./api.ts";
import { app } from "./store.svelte.ts";

class MoneyCards {
  labels = $state<string[]>([]);
  private loading = false;
  private loadedAt = 0;

  /** Load (or refresh after a minute) for the treasurer; a no-op for members. */
  refresh(force = false) {
    if (app.role !== "owner" || this.loading) return;
    if (!force && Date.now() - this.loadedAt < 60_000) return;
    this.loading = true;
    api<{ accounts: MoneyAccount[] }>("/api/admin/money")
      .then((r) => {
        this.labels = r.accounts
          .filter((a) => a.kind === "credit" && !a.archived)
          .map((a) => cardLabel(a));
        this.loadedAt = Date.now();
      })
      .catch(() => {})
      .finally(() => (this.loading = false));
  }

  /** The group's own list plus your Money cards it doesn't already name. */
  with(groupCards: readonly string[]): string[] {
    this.refresh();
    const seen = new Set(groupCards.map((c) => c.trim().toLowerCase()));
    return [...groupCards, ...this.labels.filter((l) => !seen.has(l.toLowerCase()))];
  }
}

export const moneyCards = new MoneyCards();
